import { ThunkAction, ThunkDispatch } from 'redux-thunk';

import API from '../api';
import * as types from './actionTypes';
import { IUserCredentials, IUserStore } from './types';
import { noUser } from './store';
import { forgetUser } from '../storage/user';
import { clearRequestCache } from '../api/cancellable';
import { clearLinkFiltersCache } from '../api/links/getFilters';

export const setUser = (user: IUserStore): types.ISetUser => ({
  type: types.SET_USER,
  user,
});

export const setLoginError = (msg: string): types.ISetLoginError => ({
  msg,
  type: types.SET_LOGIN_ERROR,
});

export const userLogin = (
  credentials: IUserCredentials,
  callback: () => void
): ThunkAction<Promise<void>, {}, {}, types.IUserActions> => async (
  dispatch: ThunkDispatch<{}, {}, types.IUserActions>
) => {
  try {
    const user = await API.USER.login(credentials);
    callback();
    dispatch(setUser(user));
  } catch (error) {
    callback();
    dispatch(setLoginError(error.message));
  }
};

export const userLogout = (): ThunkAction<void, {}, {}, types.IUserActions> => (
  dispatch: ThunkDispatch<{}, {}, types.IUserActions>
) => {
  clearLinkFiltersCache();
  clearRequestCache();
  forgetUser();
  dispatch(setUser(noUser));
};



// WEBPACK FOOTER //
// ./src/services/user/actionCreators.ts